/* eslint-disable import/prefer-default-export, no-unused-vars */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var modals = makeEntityScaffold('SAGA.API.MODALS', function (client, options) {
  return client.modal.get(options).then(function (data) {
    return data.modal;
  });
});